import { render, staticRenderFns } from "./switchBtn.vue?vue&type=template&id=06b0f45b&scoped=true"
import script from "./switchBtn.vue?vue&type=script&lang=js"
export * from "./switchBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0f45b",
  null
  
)

export default component.exports